
import { Component, Vue, Prop } from "vue-property-decorator";
import { getOptChart } from "@/api/api-operation-service";
import { objAny } from "@/common/common-interface";
import i18n from "@/config/i18n";
@Component
export default class PiOrderEchart extends Vue {
  @Prop({
    default: () => {
      return {};
    }
  })
  private formInline!: objAny;
  private elecEchart: objAny = {};
  private myChart: objAny = {};
  private win: objAny = window;
  private chartData: objAny = {
    dl: [],
    money: [],
    time: []
  };

  private elecData: object[] = [];

  private init(): void {
    this.getOptChart();
  }
  async getOptChart(): Promise<void> {
    const d = JSON.parse(JSON.stringify(this.formInline));
    const json: objAny = Object.assign(d, { types: [1, 3] });
    const ret = await getOptChart(this["$common"].forNull(json));
    if (ret.status === this.$config.apiStatus) {
      const data = ret.data;
      const dl: number[] = [];
      const money: number[] = [];
      const time: string[] = [];
      data.map((item: objAny) => {
        item.dataList.map((child: objAny) => {
          if (item.type == 1) {
            money.push(child.value);
            time.push(child.name);
          } else if (item.type == 3) {
            dl.push(child.value);
          }
        });
      });
      this.chartData.dl = dl;
      this.chartData.money = money;
      this.chartData.time = time;
      this.echartShow();
    }
  }

  public echartShow(): void {
    const nameArr: string[] = [];
    const valueArr: number[] = [];
    console.log(1);
    this.elecData.map((item: objAny) => {
      nameArr.push(item.name);
      valueArr.push(item.value);
    });
    const option = {
      title: {
        text: i18n.t("operationData.staDataChartTitle"),
        left: "center"
      },
      color: ["#20a0ff", "#f7ba2a"],
      tooltip: {
        trigger: "axis",
        axisPointer: {
          // 坐标轴指示器，坐标轴触发有效
          type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
        }
      },
      grid: {
        left: "5%",
        right: "4%",
        bottom: 10,
        containLabel: true
      },
      xAxis: [
        {
          type: "category",
          data: this.chartData.time,
          axisTick: {
            alignWithLabel: true
          }
        }
      ],
      yAxis: [
        {
          name: "KWH",
          type: "value"
        }
      ],
      series: [
        {
          // name: ["总电量","总金额]",
          name: i18n.t("operationData.staDataDl"),
          type: "bar",
          barWidth: "20%",
          data: this.chartData.dl
        }
        // {
        //   name: i18n.t("operationData.staDataAmount"),
        //   type: "line",
        //   data: this.chartData.money
        // }
      ]
    };
    this.myChart = this.win.echarts.init(this.elecEchart);
    this.myChart.clear();
    this.myChart.setOption(option, true);
  }

  mounted() {
    this.$nextTick(() => {
      this.elecEchart = this.$refs["elecEchart"];
    });
  }
}
